// import { useEffect, useState } from "react";
// import { BiSolidDashboard } from "react-icons/bi";
// import {
//   MdAttachMoney,
//   MdInventory,
//   MdInventory2,
//   MdOutlineCategory,
//   MdOutlineDesignServices,
//   MdViewHeadline,
// } from "react-icons/md";
// import {
//   RiArrowLeftDoubleFill,
//   RiBuildingLine,
//   RiCalendarEventFill,
//   RiComputerLine,
//   RiFileTextLine,
//   RiSplitCellsHorizontal,
// } from "react-icons/ri";
// import { TbSpeakerphone, TbBrandAbstract } from "react-icons/tb";
// import { HiOfficeBuilding, HiOutlineDocumentText } from "react-icons/hi";
// import { useLocation, useNavigate } from "react-router-dom";
// import {
//   FaMoneyBillWave,
//   FaShieldAlt,
//   FaStore,
//   FaUserFriends,
//   FaUserTie,
// } from "react-icons/fa";
// import { BsBoxSeam } from "react-icons/bs";

// const SidebarsContent = () => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const [selectedItem, setSelectedItem] = useState(location.pathname);
//   const [openGroup, setOpenGroup] = useState(null);
//   const [openMenu, setOpenMenu] = useState(null);

//   const userData = JSON.parse(localStorage.getItem("Nexgen-Admin-Data")) || {};
//   const permissions = userData.permissions || {};
//   const isAdmin = userData.userType === "admin";

//   useEffect(() => {
//     setSelectedItem(location.pathname);
//   }, [location.pathname]);

//   const toggleGroup = (groupIndex) => {
//     setOpenGroup(openGroup === groupIndex ? null : groupIndex);
//     setOpenMenu(null);
//   };

//   const toggleMenu = (menuKey) => {
//     setOpenMenu(openMenu === menuKey ? null : menuKey);
//   };

//   const classes = {
//     active:
//       "flex items-center px-4 py-2 mt-2 text-md font-normal tracking-wide text-[#2E3A8C] bg-[#cfd3ea] rounded-lg focus:outline-none focus:shadow-outline transition ease-in-out duration-300 transform hover:translate-x-2 cursor-pointer",
//     inactive:
//       "flex items-center px-4 py-2 mt-2 text-md font-normal tracking-wide text-[#ffffff] bg-transparent rounded-lg hover:text-[#535457] hover:bg-[#bcc0d7] transition ease-in-out duration-300 transform hover:translate-x-2 focus:outline-none focus:shadow-outline cursor-pointer",
//     groupHeader:
//       "flex items-center justify-between w-full px-4 py-2 mt-3 text-sm font-semibold uppercase tracking-widest text-[#ffffff] cursor-pointer hover:text-white transition-colors duration-200 select-none",
//     // groupDivider: "border-t border-[#3a4270] mt-3 mb-1",
//   };

//   const groups = [
//     {
//       label: "Advertising",
//       icon: <TbSpeakerphone size={16} />,
//       items: [
//         {
//           path: "/admin/dashboard",
//           label: "Dashboard",
//           icon: <BiSolidDashboard size={18} />,
//           permission: "Home",
//         },
//         {
//           label: "Release Order",
//           icon: <RiComputerLine size={18} />,
//           permission: "Release Order",
//           children: [
//             { path: "/admin/release-order", label: "Add Release Order" },
//             { path: "/admin/all-release-order", label: "All Release Orders" },
//           ],
//         },
//         {
//           label: "Invoice",
//           icon: <RiFileTextLine size={18} />,
//           permission: "Invoice",
//           children: [
//             { path: "/admin/add-invoice", label: "Create Invoice" },
//             { path: "/admin/all-invoice", label: "All Invoice" },
//           ],
//         },
//         {
//           label: "Split Bill",
//           icon: <RiSplitCellsHorizontal size={18} />,
//           permission: "Split Bill",
//           children: [
//             // { path: "/admin/add-split-bill", label: "Add Split Bill" },
//             { path: "/admin/all-split-bill", label: "All Split Bills" },
//           ],
//         },
//       ],
//     },
//     {
//       label: "Branding",
//       icon: <TbBrandAbstract size={16} />,
//       items: [
//         {
//           path: "/admin/branding/dashboard",
//           label: "Dashboard",
//           icon: <BiSolidDashboard size={18} />,
//           permission: "Home",
//         },
//         {
//           path: "/admin/branding/category",
//           label: "Category",
//           icon: <MdOutlineCategory size={18} />,
//           permission: "Branding-category",
//         },
//         {
//           path: "/admin/branding/vendors",
//           label: "Vendors",
//           icon: <FaStore size={18} />,
//           permission: "Branding-vendors",
//         },
//         {
//           path: "/admin/branding/referral-agencies",
//           label: "Referral Agencies",
//           icon: <FaUserFriends size={18} />,
//           permission: "Referral-Agencies",
//         },
//         {
//           path: "/admin/branding/orders",
//           label: "Orders",
//           icon: <MdOutlineDesignServices size={18} />,
//           permission: "BrandingOrders",
//         },
//       ],
//     },
//     {
//       label: "Inventory",
//       icon: <MdInventory2 size={16} />,
//       items: [
//         {
//           path: "/admin/all-vendors",
//           label: "Vendors",
//           icon: <BsBoxSeam size={18} />,
//           permission: "Vendors",
//         },
//         {
//           path: "/admin/vendor/category",
//           label: "Category",
//           icon: <BiSolidDashboard size={18} />,
//           permission: "Inventory",
//         },
//         {
//           path: "/admin/vendor/products",
//           label: "Product",
//           icon: <MdInventory size={18} />,
//           permission: "Inventory",
//         },
//         {
//           path: "/admin/vendor-purchase",
//           label: "Our Store",
//           icon: <FaStore size={18} />,
//           permission: "Store",
//         },
//         {
//           path: "/admin/vendor/buyer-data",
//           label: "Buyers",
//           icon: <FaUserTie size={18} />,
//           permission: "Inventory",
//         },
//       ],
//     },

//     {
//       label: "Own Organization",
//       icon: <HiOfficeBuilding size={16} />,
//       items: [
//         {
//           label: "Master",
//           icon: <MdViewHeadline size={18} />,
//           permission: "Master",
//           children: [
//             { path: "/admin/master/client", label: "Client" },
//             { path: "/admin/master/sub-clients", label: "Sub-Clients" },
//             { path: "/admin/master/media", label: "Media" },
//             { path: "/admin/master/agent", label: "Agent" },
//             { path: "/admin/master/staff", label: "Staff" },
//           ],
//         },
//         {
//           label: "Attendance",
//           icon: <RiFileTextLine size={18} />,
//           permission: "Attendance",
//           children: [
//             { path: "/admin/attendance", label: "Attendance" },
//             { path: "/admin/all-attendance", label: "All Attendance" },
//           ],
//         },
//         {
//           label: "Holidays",
//           icon: <RiCalendarEventFill size={18} />,
//           permission: "Holiday",
//           children: [
//             { path: "/admin/holiday", label: "All Holidays" },
//             // { path: "/admin/all-attendance", label: "All Attendance" },
//           ],
//         },
//         {
//           label: "Salary",
//           icon: <FaMoneyBillWave size={18} />,
//           permission: "Salary",
//           children: [
//             { path: "/admin/salaries", label: "Salaries" },
//             { path: "/admin/advance-salary-staff", label: "Advance Salary" },
//             // { path: "/admin/all-attendance", label: "All Attendance" },
//           ],
//         },
//         {
//           label: "LIC",
//           icon: <FaShieldAlt size={18} />,
//           permission: "Lic",
//           children: [{ path: "/admin/staff-lic", label: "Staff Lic" }],
//         },
//         {
//           label: "Quotation",
//           icon: <HiOutlineDocumentText size={18} />,
//           permission: "Quotation",
//           children: [
//             { path: "/admin/create-quotation", label: "Create-Quotation" },
//             { path: "/admin/quotation", label: "All Quotations" },
//             { path: "/admin/advertising-type", label: "Advertising type" },
//             { path: "/admin/media-rate", label: "Media Price" },
//             { path: "/admin/quotation-category", label: "Category" },
//           ],
//         },
//         {
//           path: "/admin/my-company",
//           label: "Own-Organization",
//           icon: <RiBuildingLine size={18} />,
//           permission: "Own-Organization",
//         },
//       ],
//     },
//   ];

//   const isPermitted = (permission) => {
//     if (isAdmin) return true;
//     if (!permission) return true;
//     return permissions[permission] === true;
//   };

//   const handleClick = (path) => {
//     navigate(path);
//     setSelectedItem(path);
//   };

//   return (
//     <div>
//       {groups.map((group, groupIndex) => {
//         const filteredItems = group.items.filter((item) =>
//           isPermitted(item.permission),
//         );

//         if (filteredItems.length === 0) return null;

//         const isGroupOpen = openGroup === groupIndex;

//         return (
//           <div key={groupIndex}>
//             {groupIndex > 0 && <div className={classes.groupDivider} />}

//             <div
//               className={classes.groupHeader}
//               onClick={() => toggleGroup(groupIndex)}
//             >
//               <div className="flex items-center gap-2">
//                 {group.icon}
//                 <span>{group.label}</span>
//               </div>
//               <span
//                 className={`transition-transform duration-300 ${
//                   isGroupOpen ? "rotate-90" : "-rotate-90"
//                 }`}
//               >
//                 <RiArrowLeftDoubleFill size={18} />
//               </span>
//             </div>

//             {isGroupOpen && (
//               <div className="ml-2">
//                 {filteredItems.map((item, itemIndex) => {
//                   const menuKey = `${groupIndex}-${itemIndex}`;
//                   return (
//                     <div key={itemIndex}>
//                       <div
//                         className={
//                           !item.children && selectedItem === item.path
//                             ? classes.active
//                             : classes.inactive
//                         }
//                         onClick={() =>
//                           item.children
//                             ? toggleMenu(menuKey)
//                             : handleClick(item.path)
//                         }
//                       >
//                         <div className="flex items-center justify-between w-full">
//                           <div className="flex items-center gap-2">
//                             {item.icon}
//                             <span>{item.label}</span>
//                           </div>
//                           {item.children && (
//                             <span
//                               className={`transition-transform duration-300 ${
//                                 openMenu === menuKey ? "rotate-180" : ""
//                               }`}
//                             >
//                               <RiArrowLeftDoubleFill size={20} />
//                             </span>
//                           )}
//                         </div>
//                       </div>

//                       {item.children && openMenu === menuKey && (
//                         <div className="ml-6">
//                           {item.children.map((child) => (
//                             <div
//                               key={child.path}
//                               className={
//                                 selectedItem === child.path
//                                   ? classes.active
//                                   : classes.inactive
//                               }
//                               onClick={() => handleClick(child.path)}
//                             >
//                               {child.label}
//                             </div>
//                           ))}
//                         </div>
//                       )}
//                     </div>
//                   );
//                 })}
//               </div>
//             )}
//           </div>
//         );
//       })}
//     </div>
//   );
// };

// export default SidebarsContent;

import { useEffect, useState } from "react";
import { BiSolidDashboard } from "react-icons/bi";
import {
  MdInventory,
  MdInventory2,
  MdOutlineCategory,
  MdOutlineDesignServices,
  MdViewHeadline,
} from "react-icons/md";
import {
  RiArrowDownSLine,
  RiBuildingLine,
  RiCalendarEventFill,
  RiComputerLine,
  RiFileTextLine,
  RiSplitCellsHorizontal,
} from "react-icons/ri";
import { TbSpeakerphone, TbBrandAbstract } from "react-icons/tb";
import { HiOfficeBuilding, HiOutlineDocumentText } from "react-icons/hi";
import { useLocation, useNavigate } from "react-router-dom";
import {
  FaMoneyBillWave,
  FaShieldAlt,
  FaStore,
  FaUserFriends,
  FaUserTie,
} from "react-icons/fa";
import { BsBoxSeam } from "react-icons/bs";

// ── Per-group accent colours (logo-matched) ───────────────────────────────────
// [0] Advertising → Teal  (logo primary)
// [1] Branding    → Red   (logo red block)
// [2] Inventory   → Aqua  (teal-adjacent)
// [3] Own Org     → Amber (warm complement)
const ACCENTS = [
  {
    from: "#0ec6e8",
    to: "#0e9ab5",
    dim: "rgba(14,198,232,0.12)",
    border: "rgba(14,198,232,0.26)",
    glow: "rgba(14,198,232,0.35)",
  },
  {
    from: "#f05454",
    to: "#e02020",
    dim: "rgba(224,32,32,0.12)",
    border: "rgba(224,32,32,0.26)",
    glow: "rgba(224,32,32,0.30)",
  },
  {
    from: "#2dd4bf",
    to: "#0d9488",
    dim: "rgba(45,212,191,0.11)",
    border: "rgba(45,212,191,0.24)",
    glow: "rgba(45,212,191,0.30)",
  },
  {
    from: "#fbbf24",
    to: "#f59e0b",
    dim: "rgba(251,191,36,0.11)",
    border: "rgba(251,191,36,0.24)",
    glow: "rgba(251,191,36,0.30)",
  },
];

const W07 = "rgba(255,255,255,0.06)";
const W35 = "rgba(255,255,255,0.80)";
const W55 = "rgba(255,255,255,0.55)";

const SidebarsContent = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedItem, setSelectedItem] = useState(location.pathname);
  const [openGroup, setOpenGroup] = useState(null);
  const [openMenu, setOpenMenu] = useState(null);

  const userData = JSON.parse(localStorage.getItem("Nexgen-Admin-Data")) || {};
  const permissions = userData.permissions || {};
  const isAdmin = userData.userType === "admin";

  useEffect(() => {
    setSelectedItem(location.pathname);
  }, [location.pathname]);

  const toggleGroup = (i) => {
    setOpenGroup(openGroup === i ? null : i);
    setOpenMenu(null);
  };
  const toggleMenu = (k) => setOpenMenu(openMenu === k ? null : k);
  const isPermitted = (p) => isAdmin || !p || permissions[p] === true;
  const handleClick = (path) => {
    navigate(path);
    setSelectedItem(path);
  };

  // ── Nav tree ─────────────────────────────────────────────────────────────────
  const groups = [
    {
      label: "Advertising",
      icon: <TbSpeakerphone size={14} />,
      items: [
        {
          path: "/admin/dashboard",
          label: "Dashboard",
          icon: <BiSolidDashboard size={14} />,
          permission: "Home",
        },
        {
          label: "Release Order",
          icon: <RiComputerLine size={14} />,
          permission: "Release Order",
          children: [
            { path: "/admin/release-order", label: "Add Release Order" },
            { path: "/admin/all-release-order", label: "All Release Orders" },
          ],
        },
        {
          label: "Invoice",
          icon: <RiFileTextLine size={14} />,
          permission: "Invoice",
          children: [
            { path: "/admin/add-invoice", label: "Create Invoice" },
            { path: "/admin/all-invoice", label: "All Invoices" },
          ],
        },
        {
          label: "Split Bill",
          icon: <RiSplitCellsHorizontal size={14} />,
          permission: "Split Bill",
          children: [
            { path: "/admin/all-split-bill", label: "All Split Bills" },
          ],
        },
        {
          label: "Invoice Payments",
          icon: <RiSplitCellsHorizontal size={14} />,
          permission: "Invoice",
          children: [
            {
              path: "/admin/all-invoice-payments",
              label: "All Invoice Payments",
            },
            {
              path: "/admin/all-release-order-payments",
              label: "All Release-Order Payments",
            },
          ],
        },
      ],
    },
    {
      label: "Branding",
      icon: <TbBrandAbstract size={14} />,
      items: [
        {
          path: "/admin/branding/dashboard",
          label: "Dashboard",
          icon: <BiSolidDashboard size={14} />,
          permission: "Home",
        },
        {
          path: "/admin/branding/category",
          label: "Category",
          icon: <MdOutlineCategory size={14} />,
          permission: "Branding-category",
        },
        {
          path: "/admin/branding/vendors",
          label: "Vendors",
          icon: <FaStore size={14} />,
          permission: "Branding-vendors",
        },
        {
          path: "/admin/branding/referral-agencies",
          label: "Referral Agencies",
          icon: <FaUserFriends size={14} />,
          permission: "Referral-Agencies",
        },
        {
          path: "/admin/branding/orders",
          label: "Orders",
          icon: <MdOutlineDesignServices size={14} />,
          permission: "BrandingOrders",
        },
      ],
    },
    {
      label: "Inventory",
      icon: <MdInventory2 size={14} />,
      items: [
        {
          path: "/admin/all-vendors",
          label: "Vendors",
          icon: <BsBoxSeam size={14} />,
          permission: "Vendors",
        },
        {
          path: "/admin/vendor/category",
          label: "Category",
          icon: <BiSolidDashboard size={14} />,
          permission: "Inventory",
        },
        {
          path: "/admin/vendor/products",
          label: "Products",
          icon: <MdInventory size={14} />,
          permission: "Inventory",
        },
        {
          path: "/admin/vendor-purchase",
          label: "Our Store",
          icon: <FaStore size={14} />,
          permission: "Store",
        },
        {
          path: "/admin/vendor/buyer-data",
          label: "Buyers",
          icon: <FaUserTie size={14} />,
          permission: "Inventory",
        },
      ],
    },
    {
      label: "Own Organization",
      icon: <HiOfficeBuilding size={14} />,
      items: [
        {
          label: "Master",
          icon: <MdViewHeadline size={14} />,
          permission: "Master",
          children: [
            { path: "/admin/master/client", label: "Client" },
            { path: "/admin/master/sub-clients", label: "Sub-Clients" },
            { path: "/admin/master/media", label: "Media" },
            { path: "/admin/master/agent", label: "Agent" },
            { path: "/admin/master/staff", label: "Staff" },
          ],
        },
        {
          label: "Attendance",
          icon: <RiFileTextLine size={14} />,
          permission: "Attendance",
          children: [
            { path: "/admin/attendance", label: "Attendance" },
            { path: "/admin/all-attendance", label: "All Attendance" },
          ],
        },
        {
          label: "Holidays",
          icon: <RiCalendarEventFill size={14} />,
          permission: "Holiday",
          children: [{ path: "/admin/holiday", label: "All Holidays" }],
        },
        {
          label: "Salary",
          icon: <FaMoneyBillWave size={14} />,
          permission: "Salary",
          children: [
            { path: "/admin/salaries", label: "Salaries" },
            { path: "/admin/advance-salary-staff", label: "Advance Salary" },
            { path: "/admin/salarycount", label: "15-to-15-Salary-Count" },
          ],
        },
        {
          label: "LIC",
          icon: <FaShieldAlt size={14} />,
          permission: "Lic",
          children: [{ path: "/admin/staff-lic", label: "Staff LIC" }],
        },
        {
          label: "Quotation",
          icon: <HiOutlineDocumentText size={14} />,
          permission: "Quotation",
          children: [
            { path: "/admin/create-quotation", label: "Create Quotation" },
            { path: "/admin/quotation", label: "All Quotations" },
            { path: "/admin/advertising-type", label: "Advertising Type" },
            { path: "/admin/media-rate", label: "Media Price" },
            { path: "/admin/quotation-category", label: "Category" },
          ],
        },
        {
          path: "/admin/my-company",
          label: "Own-Organization",
          icon: <RiBuildingLine size={14} />,
          permission: "Own-Organization",
        },
      ],
    },
    {
      label: "Report",
      icon: <TbBrandAbstract size={14} />,
      items: [
        {
          path: "/admin/finance-reports",
          label: "Finance Report",
          icon: <BiSolidDashboard size={14} />,
          permission: "Reports",
        },
        {
          path: "/admin/business-reports",
          label: "Business Report",
          icon: <BiSolidDashboard size={14} />,
          permission: "Reports",
        },
        {
          path: "/admin/salary-and-attendance-reports",
          label: "Salary/Attendance Report",
          icon: <BiSolidDashboard size={14} />,
          permission: "Reports",
        },
      ],
    },
  ];

  return (
    <div className="space-y-1">
      {groups.map((group, gi) => {
        const items = group.items.filter((it) => isPermitted(it.permission));
        if (!items.length) return null;

        const isOpen = openGroup === gi;
        const ac = ACCENTS[gi % ACCENTS.length];

        return (
          <div key={gi} className="mb-0.5">
            {/* ── Group header ─────────────────────────────────────────────── */}
            <button
              onClick={() => toggleGroup(gi)}
              className="group-header-wrap relative w-full flex items-center justify-between px-3 py-2.5 rounded-xl transition-all duration-200"
              style={{
                background: isOpen ? ac.dim : "transparent",
                border: isOpen
                  ? `1px solid ${ac.border}`
                  : "1px solid transparent",
              }}
              onMouseEnter={(e) => {
                if (!isOpen) e.currentTarget.style.background = W07;
              }}
              onMouseLeave={(e) => {
                if (!isOpen) e.currentTarget.style.background = "transparent";
              }}
            >
              {/* Dot + icon + label */}
              <div className="flex items-center gap-2.5">
                <span
                  className="w-1.5 h-1.5 rounded-full flex-shrink-0 transition-all duration-300"
                  style={{
                    background: `linear-gradient(135deg,${ac.from},${ac.to})`,
                    boxShadow: isOpen ? `0 0 7px ${ac.glow}` : "none",
                  }}
                />
                <span
                  style={{
                    color: isOpen ? ac.from : W35,
                    transition: "color 0.2s",
                  }}
                >
                  {group.icon}
                </span>
                <span
                  className="text-[11px] font-bold uppercase tracking-[0.1em]"
                  style={{
                    color: isOpen ? ac.from : W35,
                    transition: "color 0.2s",
                  }}
                >
                  {group.label}
                </span>
              </div>

              {/* Chevron */}
              <RiArrowDownSLine
                size={15}
                style={{
                  color: isOpen ? ac.from : W35,
                  transition: "transform 0.25s ease, color 0.2s",
                  transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
                  flexShrink: 0,
                }}
              />

              {/* Hover underline sweep */}
              <div
                className="group-underline"
                style={{
                  background: `linear-gradient(90deg,${ac.from},transparent)`,
                }}
              />
            </button>

            {/* ── Group items ──────────────────────────────────────────────── */}
            {isOpen && (
              <div className="mt-0.5 ml-1 space-y-0.5">
                {items.map((item, ii) => {
                  const mk = `${gi}-${ii}`;
                  const menuOpen = openMenu === mk;
                  const isActive = !item.children && selectedItem === item.path;

                  return (
                    <div
                      key={ii}
                      className="nav-item-animate"
                      style={{ animationDelay: `${ii * 0.03}s` }}
                    >
                      {/* Item / menu toggle button */}
                      <button
                        onClick={() =>
                          item.children
                            ? toggleMenu(mk)
                            : handleClick(item.path)
                        }
                        className="relative w-full flex items-center justify-between px-3 py-2 rounded-xl transition-all duration-150"
                        style={{
                          background: isActive
                            ? ac.dim
                            : menuOpen
                              ? W07
                              : "transparent",
                          border: isActive
                            ? `1px solid ${ac.border}`
                            : "1px solid transparent",
                        }}
                        onMouseEnter={(e) => {
                          if (!isActive) e.currentTarget.style.background = W07;
                        }}
                        onMouseLeave={(e) => {
                          if (!isActive)
                            e.currentTarget.style.background = menuOpen
                              ? W07
                              : "transparent";
                        }}
                      >
                        {/* Active left bar */}
                        {isActive && (
                          <span
                            className="nav-active-bar"
                            style={{
                              background: `linear-gradient(180deg,${ac.from},${ac.to})`,
                              boxShadow: `0 0 8px ${ac.glow}`,
                            }}
                          />
                        )}

                        {/* Icon + label */}
                        <div className="flex items-center gap-2.5 min-w-0">
                          <span
                            style={{
                              color: isActive ? ac.from : menuOpen ? W55 : W35,
                              flexShrink: 0,
                            }}
                          >
                            {item.icon}
                          </span>
                          <span
                            className="text-[12px] truncate"
                            style={{
                              color: isActive ? "#fff" : menuOpen ? W55 : W35,
                              fontWeight: isActive ? 700 : 400,
                            }}
                          >
                            {item.label}
                          </span>
                        </div>

                        {/* Expand chevron */}
                        {item.children && (
                          <RiArrowDownSLine
                            size={13}
                            style={{
                              color: W35,
                              flexShrink: 0,
                              transition: "transform 0.2s",
                              transform: menuOpen
                                ? "rotate(180deg)"
                                : "rotate(0deg)",
                            }}
                          />
                        )}
                      </button>

                      {/* ── Sub-children ──────────────────────────────────── */}
                      {item.children && menuOpen && (
                        <div
                          className="ml-5 mt-0.5 pl-3 space-y-0.5"
                          style={{ borderLeft: `1px dashed ${ac.border}` }}
                        >
                          {item.children.map((child, ci) => {
                            const ca = selectedItem === child.path;
                            return (
                              <button
                                key={child.path}
                                onClick={() => handleClick(child.path)}
                                className="nav-item-animate w-full text-left flex items-center gap-2 px-3 py-1.5 rounded-lg transition-all duration-150"
                                style={{
                                  animationDelay: `${ci * 0.03}s`,
                                  background: ca ? ac.dim : "transparent",
                                  border: ca
                                    ? `1px solid ${ac.border}`
                                    : "1px solid transparent",
                                  color: ca ? ac.from : W35,
                                  fontWeight: ca ? 600 : 400,
                                  fontSize: 11,
                                }}
                                onMouseEnter={(e) => {
                                  if (!ca) {
                                    e.currentTarget.style.background = W07;
                                    e.currentTarget.style.color = W55;
                                  }
                                }}
                                onMouseLeave={(e) => {
                                  if (!ca) {
                                    e.currentTarget.style.background =
                                      "transparent";
                                    e.currentTarget.style.color = W35;
                                  }
                                }}
                              >
                                <span
                                  className="w-1 h-1 rounded-full flex-shrink-0"
                                  style={{
                                    background: ca ? ac.from : W35,
                                    boxShadow: ca
                                      ? `0 0 5px ${ac.glow}`
                                      : "none",
                                  }}
                                />
                                {child.label}
                              </button>
                            );
                          })}
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default SidebarsContent;
